import Joi from "joi";
import React, { Component, createRef } from "react";
import { Modal } from "react-bootstrap";
import { askQuestion, getProfile } from "../actions/memberAction";
import LoadingBar from "react-top-loading-bar";
import { toast } from "react-toastify";
import { validateErrorMessage } from "./common/validation";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
const crosshair = "https://s3.amazonaws.com/media-dev.salvex.com/static/images/crosshair.svg";

class AskQuestionModal extends Component {
  ref = createRef(null);
  state = {
    page: "1",
    data: {
      name: "",
      company: "",
      phone: "",
      email: "",
      message: "",
    },
    errors: "",
    loader: false,
    loadingData: false,
  };
  schema = Joi.object({
    name: Joi.string()
      .required()
      .error((errors) => validateErrorMessage(errors)),
    company: Joi.string()
      .allow("")
      .error((errors) => validateErrorMessage(errors)),
    phone: Joi.string()
      .required()
      .error((errors) => validateErrorMessage(errors)),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .error((errors) => validateErrorMessage(errors)),
    message: Joi.string()
      .required()
      .error((errors) => validateErrorMessage(errors)),
  });
  validate = () => {
    const error = this.schema.validate(this.state.data, { abortEarly: false });
    if (error.error && error.error.details) {
      const errors = {};
      error.error.details.forEach((element) => {
        errors[element.context.key] = element.message;
      });
      this.setState({ errors });
      return false;
    }
    this.setState({ errors: "" });
    return true;
  };

  doSubmit = async (event) => {
    event.preventDefault();
    const valid = this.validate();
    if (valid) {
      this.ref.current.continuousStart();
      this.setState({ loader: true });
      const payLoad = { ...this.state.data };
      payLoad.auction_id = this.props.product.auction_id;
      payLoad.auction_title = this.props.product.title;
      const res = await askQuestion(payLoad);
      this.ref.current.complete();
      if (res.status === 200) {
        this.setState({
          loader: false,
          data: { name: "", company: "", phone: "", email: "", message: "" },
          page: "2",
        });
        toast.success(res.data.success, { theme: "colored" });
      } else {
        this.setState({ loader: false });
        toast.error("Something went wrong !", { theme: "colored" });
      }
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.show && this.props.show !== prevProps.show) {
      const profile = JSON.parse(localStorage.getItem("member"));
      if (!_.isEmpty(profile)) {
        const data = this.state.data;
        data.name = profile.name01;
        data.email = profile.email;
        data.company = profile.company_name;
        data.phone = profile.phone;
        this.setState({ data });
      } else {
        getProfile((res) => {
          if (res.status === 200) {
            const data = this.state.data;
            data.name = res.data.p_name01;
            data.email = res.data.p_email;
            data.company = res.data.p_company_name;
            data.phone = res.data.p_phone;
            this.setState({ data });
          }
        });
      }
    }
  };

  onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const data = { ...this.state.data };
    data[name] = value;
    this.setState({ data });
  };
  render() {
    const { data, errors } = this.state;
    const { show, handleClose, product } = this.props;
    return (
      <>
        <LoadingBar color="#47ad1d" ref={this.ref} />
        <Modal
          show={show}
          onHide={handleClose}
          className="modal fade salvex-modal modal-md hide-header"
          dialogClassName="modal-dialog modal-dialog-centered"
          contentClassName="ask-question-modal-height"
        >
          <Modal.Body>
            {this.state.page == "1" && (
              <>
                {this.props.loadingToken ? (
                  <>
                    <h4 class="width-90">{product.title}</h4>
                    <div class="close-btn" data-bs-dismiss="modal" onClick={handleClose}></div>
                    <p>
                      <Skeleton />
                    </p>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            <Skeleton />
                          </label>
                          <Skeleton />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            <Skeleton />
                          </label>
                          <Skeleton />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            <Skeleton />
                          </label>
                          <Skeleton />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            <Skeleton />
                          </label>
                          <Skeleton />
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-0">
                      <label for="message" class="form-label">
                        <Skeleton />
                      </label>
                      <Skeleton height="180px" />
                    </div>
                  </>
                ) : (
                  <>
                    <h4 class="width-90">{product.title}</h4>
                    <div class="close-btn" data-bs-dismiss="modal" onClick={handleClose}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18 6L6 18"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 6L18 18"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <p>Fill out the form below to send a question to {product.trader}:</p>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            name="name"
                            value={data.name}
                            onChange={this.onChange}
                          />
                          {errors.name && <label className="error">{errors.name}</label>}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            Company
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="company"
                            name="company"
                            value={data.company}
                            onChange={this.onChange}
                          />{" "}
                          {errors.company && <label className="error">{errors.company}</label>}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="company" class="form-label">
                            Phone
                          </label>
                          <input
                            type="tel"
                            class="form-control"
                            id="phone"
                            name="phone"
                            value={data.phone}
                            onChange={this.onChange}
                          />{" "}
                          {errors.phone && <label className="error">{errors.phone}</label>}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="email" class="form-label">
                            Email
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            id="email"
                            name="email"
                            value={data.email}
                            onChange={this.onChange}
                          />{" "}
                          {errors.email && <label className="error">{errors.email}</label>}
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-0">
                      <label for="message" class="form-label">
                        Message
                      </label>
                      <textarea
                        class="form-control ask-question-textarea"
                        id="message"
                        name="message"
                        onChange={this.onChange}
                        value={data.message}
                      ></textarea>{" "}
                      {errors.message && <label className="error">{errors.message}</label>}
                    </div>
                  </>
                )}
              </>
            )}
            {this.state.page == "2" && (
              <>
                <div class="sucessfull-askQuestion-box  sucessfull-submit-box help-box-success">
                  <img src={crosshair} alt="crosshair" />
                  <h4 style={{ fontSize: "1.25rem" }}>
                    Thank you for your enquiry. We will get back to you right away.
                  </h4>
                  <button
                    type="button"
                    class={`btn btn-default btn-sm`}
                    onClick={() => {
                      this.setState({ page: "1" });
                      handleClose();
                    }}
                  >
                    Close
                  </button>
                </div>
              </>
            )}
          </Modal.Body>
          {this.state.page == "1" && (
            <div class="modal-footer">
              {this.props.loadingToken ? (
                <Skeleton />
              ) : (
                <a
                  href="javascript:void(0)"
                  class={this.state.loader ? "btn btn-default btn-sm disabled" : "btn btn-default btn-sm"}
                  onClick={this.doSubmit}
                >
                  Send
                </a>
              )}
            </div>
          )}
          <Modal.Footer></Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default AskQuestionModal;
